import { css } from 'linaria';

export const storeItemMarginBottom = 16;

const borderTransition = `
  transition-timing-function: ease-out;
  transition-duration: 100ms, 100ms;
  transition-property: border-width, border-color;
`;

export const storeItem = css`
  width: 100%;
  margin-bottom: ${storeItemMarginBottom}px;
  border: 1px solid var(--control-secondary);
  border-radius: var(--rounding-m);
  ${borderTransition}
`;

export const activeStore = css`
  border-width: 2px;
  border-color: var(--control-primary);
  ${borderTransition}
`;

export const itemHeader = css`
  display: flex;
`;

export const storeButton = css`
  justify-content: start;
  width: 100%;
  padding: calc(var(--space-250) - 1px);
  border: none;
`;

export const activeButton = css`
  width: calc(100% - var(--space-525));
  padding: var(--space-225) 0 calc(var(--space-250) - 1px) var(--space-225);
`;

export const closeButton = css`
  padding: var(--space-225) var(--space-225) var(--space-225) 0;
  border: none;
`;

export const storeItemTitle = css`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-align: start;
  text-overflow: ellipsis;
`;

export const styles = {
  storeItem,
  activeStore,
  itemHeader,
  storeButton,
  activeButton,
  closeButton,
  storeItemTitle,
};
